module.exports = __webpack_public_path__ + "img/bm.a4498a96.svg";